import { MessageCircle } from "lucide-react";
import classes from "./classes.module.scss";
import I18n from "components/materials/I18n";
import Typography from "components/elements/Typography";

export function EmptyComments() {
	return (
		<div className={classes["root"]}>
			<MessageCircle />
			<Typography type="p" weight="bold" size="large">
				{I18n.asset.pages.post.comment.empty}
			</Typography>
			<Typography type="p" weight="regular" size="medium">
				{I18n.asset.pages.post.comment.share}
			</Typography>
		</div>
	);
}
